import { ImageBlockDto } from './image-block.dto';

export class ImageBlock {
    readonly id: string;
    readonly url: string;

    constructor(dto: ImageBlockDto) {
        this.id = dto.id;
        this.url = dto.url;
    }
}
